import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "locationResources",
  initialState: {
    location : "",
    locationResourceList: [],
    pinArray:[]
  },
  reducers: {
    loadLocationResources: () => {},
    loadLocationResourcesSuccess: (state, action) => {
      state.locationResourceList = action.payload.data.resourceList;
    },
    setLocationResources: (state, action) => {
      state.locationResourceList = action.payload;
    },
    loadLocationResourcesFailure: () => {},
    addLocationResource :() => {},
    editLocationResource :() => {},
    setLocation : (state,action) => {
      state.location = action.payload;
    },
    loadPins :() => {},
    setPins: (state, action) => {
      state.pinArray = action.payload;
    },
    markPin:()=>{}
  },
});

export const {
  loadLocationResources,
  loadLocationResourcesSuccess,
  loadLocationResourcesFailure,
  addLocationResource,
  editLocationResource,
  setLocation,
  setLocationResources,
  loadPins,
  setPins,
  markPin
} = counterSlice.actions;

export default counterSlice.reducer;

export const getLocationResources = (state) => state.locationResources.locationResourceList;

export const pinsLength = (state) => state.locationResources.pinArray.length;

